/**
 * Wall Pocket PDP — engraving, preview, color label, ATC price, stock
 */
(function () {
  'use strict';

  function getProductForm(formId) {
    return document.getElementById(formId) || document.forms[formId] || null;
  }

  function ensureFormPropertyInput(root, form) {
    var propertyName = root.getAttribute('data-property-name');
    if (!form || !propertyName) return null;

    var existing = form.querySelector('[data-wp-engraving-form-input]');
    if (existing) return existing;

    var hidden = document.createElement('input');
    hidden.type = 'hidden';
    hidden.name = propertyName;
    hidden.setAttribute('data-wp-engraving-form-input', '');
    hidden.disabled = true;
    form.appendChild(hidden);
    return hidden;
  }

  function syncToForm(visibleInput, formInput) {
    if (!formInput) return;
    var value = (visibleInput.value || '').trim();
    if (!value) {
      formInput.value = '';
      formInput.disabled = true;
      return;
    }
    formInput.value = value;
    formInput.disabled = false;
  }

  function updatePreview(root, visibleInput) {
    var preview = root.querySelector('[data-wp-engraving-preview]');
    var previewText = root.querySelector('[data-wp-engraving-preview-text]');
    if (!preview || !previewText) return;

    var value = (visibleInput.value || '').trim();
    if (!value) {
      preview.hidden = true;
      previewText.textContent = '';
      return;
    }

    var prefix = root.getAttribute('data-preview-prefix') || '';
    preview.hidden = false;
    previewText.textContent = prefix + value.toUpperCase();
  }

  function initEngraving(root) {
    var presets = root.querySelectorAll('[data-wp-engraving-preset]');
    var visibleInput = root.querySelector('[data-wp-engraving-input]');
    var fieldWrap = root.querySelector('[data-wp-engraving-field]');
    var preview = root.querySelector('[data-wp-engraving-preview]');
    var form = getProductForm(root.getAttribute('data-form-id'));
    var formInput = ensureFormPropertyInput(root, form);
    if (!visibleInput || presets.length === 0) return;

    var activePreset = null;

    function clearPresets() {
      presets.forEach(function (btn) {
        btn.setAttribute('aria-pressed', 'false');
      });
    }

    function selectPreset(btn) {
      clearPresets();
      btn.setAttribute('aria-pressed', 'true');
      activePreset = btn;

      var isOptOut = btn.getAttribute('data-wp-engraving-opt-out') === 'true';
      var isCustom = btn.getAttribute('data-wp-engraving-custom') === 'true';
      var placeholder = btn.getAttribute('data-wp-engraving-placeholder') || '';

      if (isOptOut) {
        if (fieldWrap) fieldWrap.hidden = true;
        if (preview) preview.hidden = true;
        visibleInput.value = '';
        syncToForm(visibleInput, formInput);
        return;
      }

      if (fieldWrap) fieldWrap.hidden = false;
      visibleInput.placeholder = placeholder || visibleInput.getAttribute('data-default-placeholder') || '';
      syncToForm(visibleInput, formInput);
      updatePreview(root, visibleInput);

      if (isCustom) visibleInput.focus();
    }

    var defaultPlaceholder = visibleInput.getAttribute('placeholder') || '';
    visibleInput.setAttribute('data-default-placeholder', defaultPlaceholder);

    presets.forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectPreset(btn);
      });
    });

    visibleInput.addEventListener('input', function () {
      syncToForm(visibleInput, formInput);
      updatePreview(root, visibleInput);
    });

    if (form) {
      form.addEventListener('submit', function () {
        syncToForm(visibleInput, formInput);
      }, true);
    }

    var defaultBtn =
      root.querySelector('[data-wp-engraving-default="true"]') ||
      root.querySelector('[data-wp-engraving-opt-out="true"]') ||
      presets[0];

    if (defaultBtn) selectPreset(defaultBtn);
  }

  function initColorLabel(section) {
    var colorStep = section.querySelector('[data-wp-color-step]');
    if (!colorStep) return;

    var label = colorStep.querySelector('[data-wp-color-value]');
    var formId = section.querySelector('[data-wp-engraving]')?.getAttribute('data-form-id')
      || section.querySelector('[data-wp-buy-zone]')?.getAttribute('form')
      || section.querySelector('[data-wp-stock-line]')?.getAttribute('data-form-id');

    if (!formId) {
      var buyForm = section.querySelector('form[is="product-form"]');
      if (buyForm) formId = buyForm.id;
    }

    var form = formId ? getProductForm(formId) : null;
    if (!form || !label) return;

    form.addEventListener('variant:change', function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;
      var color = variant.title.split(' / ').pop();
      if (variant.options && variant.options.length) {
        color = variant.options[variant.options.length - 1] || color;
      }
      label.textContent = color;
    });
  }

  function initAtcPrice(section) {
    var buyZone = section.querySelector('[data-wp-buy-zone]');
    if (!buyZone) return;

    var formId = buyZone.getAttribute('form');
    var form = formId ? getProductForm(formId) : buyZone.querySelector('form');
    var submitBtn = buyZone.querySelector('button[type="submit"]');
    if (!form || !submitBtn) return;

    function formatMoney(cents) {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, window.themeVariables?.settings?.moneyFormat || '${{amount}}');
      }
      return '$' + (cents / 100).toFixed(2);
    }

    var base =
      buyZone.getAttribute('data-wp-atc-base') ||
      submitBtn.getAttribute('data-wp-atc-base') ||
      'ADD TO CART';
    submitBtn.setAttribute('data-wp-atc-base', base);

    var stickyScope = section.closest('.shopify-section') || document;
    var stickyButtons = stickyScope.querySelectorAll('[data-wp-sticky-atc]');
    stickyButtons.forEach(function (btn) {
      btn.setAttribute('data-wp-atc-base', base);
    });

    function setAtcLabel(text) {
      submitBtn.textContent = text;
      stickyButtons.forEach(function (btn) {
        btn.textContent = text;
      });
    }

    function updateLabel(variant) {
      if (!variant) return;
      setAtcLabel(base + ' — ' + formatMoney(variant.price));
    }

    var salePrice = section.querySelector('sale-price[form="' + form.id + '"]');
    if (salePrice) {
      var observer = new MutationObserver(function () {
        var text = salePrice.textContent.trim();
        if (text) {
          var currentBase = submitBtn.getAttribute('data-wp-atc-base') || 'ADD TO CART';
          setAtcLabel(currentBase + ' — ' + text);
        }
      });
      observer.observe(salePrice, { childList: true, subtree: true, characterData: true });
    }

    form.addEventListener('variant:change', function (event) {
      updateLabel(event.detail && event.detail.variant);
    });

    var salePriceEl = section.querySelector('sale-price[form="' + form.id + '"]');
    if (salePriceEl && salePriceEl.textContent.trim()) {
      setAtcLabel(base + ' — ' + salePriceEl.textContent.trim());
    }
  }

  function initStickyBarPadding(section) {
    var scope = section.closest('.shopify-section') || document;
    var stickyBar = scope.querySelector('.wp-pdp__sticky-bar');
    if (!stickyBar) return;

    function syncPadding() {
      document.documentElement.style.paddingBottom = stickyBar.classList.contains('is-visible')
        ? stickyBar.offsetHeight + 'px'
        : '';
    }

    syncPadding();
    new MutationObserver(syncPadding).observe(stickyBar, {
      attributes: true,
      attributeFilter: ['class']
    });
    window.addEventListener('resize', syncPadding);
  }

  function initStickyScroll(section) {
    var scope = section.closest('.shopify-section') || document;
    var triggers = scope.querySelectorAll('[data-wp-sticky-scroll]');
    triggers.forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        var selector = btn.getAttribute('data-wp-sticky-scroll');
        var target = selector
          ? section.querySelector(selector) || scope.querySelector(selector) || document.querySelector(selector)
          : null;
        if (!target) return;
        var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  function initStockLine(section) {
    var stockLine = section.querySelector('[data-wp-stock-line]');
    if (!stockLine) return;

    var form = getProductForm(stockLine.getAttribute('data-form-id'));
    var textEl = stockLine.querySelector('[data-wp-stock-text]');
    var suffix = stockLine.getAttribute('data-suffix') || 'in stock';
    if (!form || !textEl) return;

    form.addEventListener('variant:change', function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;
      if (variant.available) {
        textEl.textContent = suffix;
      }
    });
  }

  function initInstallTrigger(section) {
    section.querySelectorAll('[data-wp-install-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var carouselId = btn.getAttribute('aria-controls');
        var carousel = carouselId ? document.getElementById(carouselId) : null;
        if (!carousel) return;

        var videoSlide = carousel.querySelector('[data-media-type="video"]');
        if (videoSlide) {
          var index = Array.prototype.indexOf.call(carousel.children, videoSlide);
          if (index >= 0 && typeof carousel.select === 'function') {
            carousel.select(index);
          } else {
            videoSlide.scrollIntoView({ behavior: 'smooth', inline: 'center' });
          }
        }
      });
    });
  }

  function initInstallModal(section) {
    section.querySelectorAll('[data-wp-install-modal]').forEach(function (btn) {
      var modalId = btn.getAttribute('data-wp-install-modal');
      var modal = document.getElementById(modalId);
      if (!modal) return;

      var video = modal.querySelector('.wp-install-modal__video');

      function openModal() {
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
        if (video) video.play().catch(function () {});
        modal.focus();
      }

      function closeModal() {
        modal.hidden = true;
        document.body.style.overflow = '';
        if (video) {
          video.pause();
          video.currentTime = 0;
        }
        btn.focus();
      }

      btn.addEventListener('click', openModal);

      modal.querySelectorAll('[data-wp-install-modal-close]').forEach(function (el) {
        el.addEventListener('click', closeModal);
      });

      modal.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeModal();
      });
    });
  }

  function initDisclosure(toggle, panel) {
    if (!toggle || !panel) return;
    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      panel.hidden = expanded;
      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    });
  }

  // "Find Your Perfect Size": selecting an item recommends the SMALLEST size
  // that fits it, highlights that size card, and reveals a pre-rendered
  // explanation card (description + what fits / what doesn't) for that size.
  function initUseCases(section) {
    var group = section.querySelector('[data-wp-use-cases]');
    if (!group) return;

    var chips = Array.prototype.slice.call(
      group.querySelectorAll('[data-wp-use-case-trigger]')
    );
    if (!chips.length) return;

    var lens = group.closest('[data-wp-use-case-lens]') || section;
    var cards = Array.prototype.slice.call(
      section.querySelectorAll('[data-wp-size-cards] [data-wp-size]')
    );
    var sizes = ['small', 'medium', 'large'];
    var recCards = {};
    sizes.forEach(function (size) {
      recCards[size] = lens.querySelector('[data-wp-rec-card="' + size + '"]');
    });

    // smallest size whose fit flag is true for this item
    function recommendedSize(chip) {
      for (var i = 0; i < sizes.length; i++) {
        if (chip.getAttribute('data-fits-' + sizes[i]) === 'true') return sizes[i];
      }
      return null;
    }

    function clearState() {
      chips.forEach(function (c) {
        c.classList.remove('is-selected');
        c.setAttribute('aria-pressed', 'false');
      });
      cards.forEach(function (card) {
        card.classList.remove('is-recommended', 'is-dimmed');
      });
      sizes.forEach(function (size) {
        if (recCards[size]) recCards[size].hidden = true;
      });
    }

    function selectChip(chip) {
      var size = recommendedSize(chip);
      if (!size) {
        clearState();
        return;
      }

      chips.forEach(function (c) {
        var active = c === chip;
        c.classList.toggle('is-selected', active);
        c.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      cards.forEach(function (card) {
        var cardSize = (card.getAttribute('data-wp-size') || '').toLowerCase();
        var rec = cardSize === size;
        card.classList.toggle('is-recommended', rec);
        card.classList.toggle('is-dimmed', !rec);
      });

      sizes.forEach(function (s) {
        if (recCards[s]) recCards[s].hidden = s !== size;
      });
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        if (chip.classList.contains('is-selected')) {
          clearState();
        } else {
          selectChip(chip);
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-wp-engraving]').forEach(initEngraving);

    document.querySelectorAll('[data-wp-size-guide-toggle]').forEach(function (toggle) {
      var panelId = toggle.getAttribute('aria-controls');
      initDisclosure(toggle, panelId ? document.getElementById(panelId) : null);
    });

    document.querySelectorAll('[data-wp-pdp-section]').forEach(function (section) {
      initColorLabel(section);
      initAtcPrice(section);
      initStockLine(section);
      initInstallTrigger(section);
      initInstallModal(section);
      initStickyBarPadding(section);
      initStickyScroll(section);
      initUseCases(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
